/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Dashboard 2 React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Dashboard 2 React using thie file.
 */

const colors = {
  background: {
    default: "#152a35", // Deep navy for primary backgrounds
    secondary: "#1d3b49", // Lighter blue for secondary backgrounds
  },

  text: {
    main: "#e5d6c3", // Cream for body text
    focus: "#5d7052", // Muted green for headings
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#152a35", // Deep navy
    focus: "#1d3b49", // Lighter blue
  },

  secondary: {
    main: "#7f8e99", // Gray for containers
    focus: "#6c7a84",
  },

  info: {
    main: "#1A73E8",
    focus: "#1662C4",
  },

  success: {
    main: "#4CAF50",
    focus: "#67bb6a",
  },

  warning: {
    main: "#fb8c00",
    focus: "#fc9d26",
  },

  error: {
    main: "#F44335",
    focus: "#f65f53",
  },

  light: {
    main: "#e5d6c3", // Cream
    focus: "#d4c2ad",
  },

  dark: {
    main: "#152a35", // Deep navy
    focus: "#1d3b49", // Lighter blue
  },

  gold: {
    main: "#c2a66e", // Gold for CTAs
    focus: "#a88c5a",
  },

  olive_green: {
    main: "#5d7052", // Olive green
    focus: "#4a5c40",
  },

  soft_cream: {
    main: "#e5d6c3", // Cream
    focus: "#d4c2ad",
  },

  slate_gray: {
    main: "#7f8e99", // Slate gray
    focus: "#6c7a84",
  },

  navy:{
    main: "#1d3b49",
    focus: "#2c596d",
  },

  dark_teal: {
    main: "#152a35",
    focus: "#24485b",
  },
  
  stormblue: {
    main: "#2B5587", // Storm blue
    focus: "#2B4D76", // Darker storm blue
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#7f8e99", // Main gray for containers
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#152a35", // Deep navy
      state: "#1d3b49", // Lighter blue
    },

    secondary: {
      main: "#7f8e99", // Gray
      state: "#6c7a84",
    },

    info: {
      main: "#49a3f1",
      state: "#1A73E8",
    },

    success: {
      main: "#66BB6A",
      state: "#43A047",
    },

    warning: {
      main: "#FFA726",
      state: "#FB8C00",
    },

    error: {
      main: "#EF5350",
      state: "#E53935",
    },

    light: {
      main: "#e5d6c3", // Cream
      state: "#d4c2ad",
    },

    dark: {
      main: "#152a35", // Deep navy
      state: "#1d3b49", // Lighter blue
    },

    navy: {
      main: "#152a35", // Deep navy
      state: "#1d3b49", // Lighter blue
    },

    gold: {
      main: "#c2a66e", // Gold for CTAs
      state: "#b4914b",
    },
    
    olive_green: {
      main: "#5d7052", // Olive green for CTAs
      state: "#4a5c40",
    },

    stormblue: {
      main: "#668EBE", // Light storm blue
      state: "#2B5587", // Dark storm blue
    },
  },

  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b",
    },

    secondary: {
      background: "#d7d9e1",
      text: "#6c757d",
    },

    info: {
      background: "#aecef7",
      text: "#095bc6",
    },

    success: {
      background: "#bce2be",
      text: "#339537",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#fcd3d0",
      text: "#f61200",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#e91e62",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
    navy: "#1d3b49",
    dark_teal: "#152a35",
    stormblue: "#2B5587",
  },

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
